<template>
<div v-cloak>
  <div>
    <v-toolbar class="main">
      <button class="nav-back" @click="goBack"><v-icon>keyboard_arrow_left</v-icon> Logga ut</button>
    </v-toolbar>
    <div>
      <span style="float:left"><h1 class="title-go-left" style="margin-bottom: 10px;">Välj kund</h1></span><span style="float: right; line-height: 50px" v-if="!$store.state.deviceLocation.hasBeenSet">Hämtar position...</span>

      <v-text-field class="mb-2" placeholder="Sök på namn" icon="search" v-model="filter"></v-text-field>
    </div>
    <!-- Search End -->
    <center style="padding-top: 15px">
        <!-- PROCESSING -->
        <v-progress-circular v-if="this.$store.state.fetchPending && !this.$store.state.fetchFailed" indeterminate :size="70" :width="7" color="green"></v-progress-circular>
        <br>
        <span v-if="this.$store.state.fetchPending && !this.$store.state.fetchFailed">Hämtar enhetens plats och kundlista.<br>Det kan ta lite tid.</span>
        <!-- FAILED -->
        <v-icon v-if="this.$store.state.fetchFailed" x-large color="red darken-2">error</v-icon>
    </center>
    <vue-virtual-list v-if="!this.$store.state.fetchPending" :row-height="148" :dynamic-height="false">
        <div v-for="(customer, i) in getCustomers" :key="i">
            <v-btn block class="driver-home-btn"  @click="$store.state.customDialogTrigger = !$store.state.customDialogTrigger; setCurrentDialog(customer)">
                <div>
                    <h3><span class="button-text-overflow">{{ customer.name }}</span></h3>
                    <br>
                    {{ customer.address.street }}
                    <br>
                    <span>{{ customer.address.postal }}</span>
                    <span v-if="$store.state.deviceLocation.hasBeenSet" style="float: right; " >{{ customer.dist }} km</span>
                    <span v-if="!$store.state.deviceLocation.hasBeenSet" style="float: right;"><v-progress-circular indeterminate :size="20" :width="4" color="green"></v-progress-circular> km</span>
                    <!--span v-if="!$store.state.deviceLocation.hasBeenSet" style="float: right; ">calculating... km</span-->
                </div>
            </v-btn>
        </div>
    </vue-virtual-list>
       <!-- CUSTOM DIALOG ELEMENT -->
    <customDialog>
    </customDialog>
     <!-- CUSTOM DIALOG ELEMENT END -->
        <ul style="list-style: none;">
            <li v-if="getCustomers.length === 0 && !this.$store.state.fetchPending" :xs="24" :sm="24" :md="24">
                <center><h4>Ingen matchning hittad</h4></center>
            </li>
        </ul>
    </div>
</div> <!-- #app -->
</template>
<script>
    import vl from 'vue-virtual-list'
    import customDialog from './Custom_Dialog'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        components: {
            vueVirtualList: vl,
            customDialog:customDialog
        },
        name: 'Test',
        data: function data() {
            return {
                dialog: false,
                filter: '',
                sort: 'Distance',
                lat: null,
                lng: null,
                sortedByDist: false,
                successSnack: true,
                settingDistance: true
            }
        },
        methods: {
            setCurrentDialog(customer){
                this.$store.state.currentDialog = customer;
            },
            triggerCustomDialog(customer){
                this.$store.state.customDialogTrigger = true;
            },
            goToDirections(){
                this.$router.push('Directions');
            },
            goBack(){
                this.$store.commit('unsetActiveProfile');
                this.$router.push('/');
            },
            ...mapActions([
                'setActiveProfile',
                'printName'
            ])
        },
        computed: {
            getCustomers: function getCustomers() {
                var _this = this;

                let position = this.$store.state.deviceLocation.position;
                //this.customers = this.$store.state.currentCustomers.slice(0, 50);
                var customers = this.$store.state.currentCustomers.filter(function (player) {
                    return player.name.toLowerCase().indexOf(_this.filter.toLowerCase()) !== -1;
                });

                if(!this.$store.state.deviceLocation.hasBeenSet){
                    customers.sort(function(a, b){
                        if(a.name < b.name) return -1;
                        if(a.name > b.name) return 1;
                        return 0;
                    })
                } else {
                    // set the current distance between customers and user device
                    customers.forEach(function(customer){
                        var R = 6371; // Radius of the earth in km
                        var dLat = (Math.PI/180)*(customer.address.latitude-position.coords.latitude);  // deg2rad below
                        var dLon = (Math.PI/180)*(customer.address.longitude-position.coords.longitude);
                        var a =
                            Math.sin(dLat/2) * Math.sin(dLat/2) +
                            Math.cos((Math.PI/180)*(customer.address.latitude)) * Math.cos((Math.PI/180)*(position.coords.latitude)) *
                            Math.sin(dLon/2) * Math.sin(dLon/2);
                        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
                        var d = R * c; // Distance in km
                        customer.dist = Math.round(d);
                        return customer.dist;
                    })
                }

                // sort the list of customers by distance
                customers.sort(function(a,b){
                    return a.dist - b.dist;
                })

                return customers;
            }
        },
        created: function(){

            this.$store.state.fetchFailed = false;

            if(this.$store.state.auth.token == null || this.$store.state.auth.token == ""){
                window.alert("Fel: Vänligen logga in");
                this.$router.push('/');
            }

            if (this.$store.state.currentCustomers.length < 1) {
                this.$store.commit("getCustomers");
            }

            /*
            this.$store.state.currentCustomers.sort(function(a,b){
                if(a == null){
                    NaNFix(a);
                }

                if(b == null){
                    NaNFix(b);
                }

                return a.dist-b.dist
            })*/
            //this.sortArray(this.$store.state.currentCustomers);

        }
    }
</script>
<style>
    [v-cloak] {
        display: none;
    }
    .search-input {
        background-color: white;
        margin: 10px;
        padding: 10px;
    }

    .driver-home-btn{
        display: inline!important;
        text-align: left;
        justify-content: left;
        padding: 13px;
        padding-left: 10px;
        padding-right: 10px;
        margin-bottom: 10px!important;
        background-color: white!important;
        font-size: 18px;
        height: auto;
        border-radius: 7px;
    }

    .btn__content {
        font-family: 'Roboto', sans-serif;
        align-items: left;
        border-radius: inherit;
        color: inherit;
        display: inline!important;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: left;
        transition: .3s cubic-bezier(.25,.8,.5,1);
        white-space: nowrap;
        padding: 0!important;
        margin: 0;
    }

    .button-text-overflow {
        width: 295px;
        overflow: hidden;
        white-space: nowrap;
        display: block;
        text-overflow: ellipsis;
        padding: 0;
        margin: 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Driver_Home.vue